import { USER_ROLES } from '../../../constants/keycloak';
import { useCRMUser } from '../../../contexts/CRMUserContext';
import AffiliateCommissionTab from './AffiliateCommissionTab';
import AgentCommissionTab from './AgentCommissionTab';

const CRMCommissionTab = () => {
  const { selectedCRMUser } = useCRMUser();

  return selectedCRMUser?.role?.name === USER_ROLES.AFFILIATE ? <AffiliateCommissionTab /> : <AgentCommissionTab />;
};

export default CRMCommissionTab;
